import axios from 'axios'
import stroe from '@/store'
import router from '@/router'
// import { Message } from 'element-ui'
import Vue from 'vue'
import LoginBox from '@/components/LoginBox.vue'
import { removeToken } from '@/utils/auth'

// 创建一个新的axios实例
const service = axios.create({})

// 接口响应时间
let responseTime = 0

// 请求拦截器 => 处理token统一注入
service.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('kakacloAdminToken')
    if (token && config.url !== '/api/oauth/login') {
      config.headers.Authorization = `Bearer ${token}`
      config.headers['Language-Id'] = 1
    }
    config.headers['Language-Id'] = 1
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // TODO 此处需要对错误的状态码做统一的拦截处理
    return response.data
  },
  (error) => {
    if (error.response.status === 401) {
      // if (error.response.data.code === 110005) {
        if (new Date().getTime() - 60000 > responseTime) {
          responseTime = new Date().getTime()
          const comp = new (Vue.extend(LoginBox))().$mount()
          document.body.appendChild(comp.$el)
        }
      // } else {
      //   stroe.dispatch('user/logout')
      //   router.replace('/login')
      // }
    }
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error.response)
  }
)

// 导出axios实例
export default service
